"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateString = exports.isISOString = exports.isCalendarDateObject = exports.toUnicodeDateTokenFormat = exports.prependWithZero = exports.getLocalTimezone = exports.getLocalDateInputFormat = exports.DateInputFormatPlaceholder = exports.DateInputFormat = exports.LA_TIMEZONE = exports.UTC_TIMEZONE = exports.AUSTRALIA_TIMEZONE = exports.DATE_STRING_DIVIDER = exports.DATE_STRING_FORMAT = void 0;
var dateFn = __importStar(require("date-fns"));
var date_fns_tz_1 = require("date-fns-tz");
var lodash_1 = require("lodash");
var isObject_1 = __importDefault(require("lodash/isObject"));
exports.DATE_STRING_FORMAT = 'yyyy-MM-dd';
exports.DATE_STRING_DIVIDER = '-';
exports.AUSTRALIA_TIMEZONE = 'Australia/Sydney';
exports.UTC_TIMEZONE = 'UTC';
exports.LA_TIMEZONE = 'America/Los_Angeles';
var DateInputFormat;
(function (DateInputFormat) {
    DateInputFormat["YEAR_FIRST"] = "yyyy-MM-dd";
    DateInputFormat["DAY_FIRST"] = "d/M/yyyy";
    DateInputFormat["AMERICAN"] = "MM/dd/yyyy";
})(DateInputFormat = exports.DateInputFormat || (exports.DateInputFormat = {}));
exports.DateInputFormatPlaceholder = (_a = {},
    _a[DateInputFormat.YEAR_FIRST] = 'YYYY-MM-DD',
    _a[DateInputFormat.DAY_FIRST] = 'DD/MM/YYYY',
    _a[DateInputFormat.AMERICAN] = 'MM/DD/YYYY',
    _a);
/**
 * Returns the DateFormat used by the locale.
 * @returns DateFormat
 */
function getLocalDateInputFormat() {
    var language = navigator.language;
    if (language === 'en-US') {
        return DateInputFormat.AMERICAN;
    }
    return DateInputFormat.DAY_FIRST;
}
exports.getLocalDateInputFormat = getLocalDateInputFormat;
/**
 * Returns the client local timezone.
 */
function getLocalTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}
exports.getLocalTimezone = getLocalTimezone;
/**
 * Prepend a number less than 10 with a 0.
 */
function prependWithZero(num) {
    if (num < 10) {
        return "0".concat(num);
    }
    return String(num);
}
exports.prependWithZero = prependWithZero;
/**
 * Takes the legacy format string and returns a new format string used by
 * date-fns v2. This means we not need to update every date picker input.
 * @param format The format string
 * @returns Updated format string
 */
function toUnicodeDateTokenFormat(format) {
    return format.replace(/D{2}/, 'dd').replace(/D{1}/, 'd').replace(/Y{4}/, 'yyyy').replace(/d{3}/, 'eee');
}
exports.toUnicodeDateTokenFormat = toUnicodeDateTokenFormat;
/**
 * Taken from is-iso-date npm package which didn't have types
 * @see https://github.com/honeinc/is-iso-date
 */
var isoDateRegExp = new RegExp(
// eslint-disable-next-line max-len
/(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/);
/**
 * Determine if a give value is a CalendarDate object.
 */
function isCalendarDateObject(value) {
    if (!(0, isObject_1.default)(value)) {
        return false;
    }
    return (0, lodash_1.isNumber)((0, lodash_1.get)(value, 'year')) && (0, lodash_1.isNumber)((0, lodash_1.get)(value, 'month')) && (0, lodash_1.isNumber)((0, lodash_1.get)(value, 'day'));
}
exports.isCalendarDateObject = isCalendarDateObject;
/**
 * Determine if the string that has been passed in is an ISO string.
 */
function isISOString(value) {
    if (typeof value !== 'string')
        return false;
    return isoDateRegExp.test(value);
}
exports.isISOString = isISOString;
/**
 * Check to see if a string is a DateString in the format yyyy-MM-dd.
 */
function isDateString(value) {
    if (typeof value !== 'string')
        return false;
    if (value.length !== exports.DATE_STRING_FORMAT.length)
        return false;
    try {
        var date = (0, date_fns_tz_1.toDate)(value, {
            timeZone: exports.UTC_TIMEZONE,
        });
        return dateFn.isValid(date);
    }
    catch (e) {
        return false;
    }
}
exports.isDateString = isDateString;
